import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import { updateFilter, showFilter } from '../../../../../store/actions/filter.actions';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { updateSkip } from '../../../../../store/actions/datatable.actions';
import DialogConfirmCancel from '../../../../dialog/DialogConfirm';
import FormCurriculumElements from './FormCurriculumElements';
import InputField from '../../../../FormControl/input/InputField';
import { Typography } from '@mui/material';
import SelectField from '../../../../FormControl/input/SelectField';

const FilterDialog = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const curriculumList = useSelector((state) => state?.assessment?.curriculum);
  const existLinceseAssessment = useSelector((state) =>
    state?.tenant?.license?.find((license) => license.code === 'assessment')
  );
  const { curriculumId } = useParams();
  const filter = useSelector((state) => state?.filter.subject?.filter || {});
  const open = useSelector((state) => state?.filter.subject?.open || false);

  const dispatch = useDispatch();

  const [form, setInputForm] = useState(filter);

  useEffect(() => {
    if (!isEmpty(filter)) {
      setInputForm(filter);
    }
  }, [filter]);

  const onClose = () => {
    dispatch(showFilter('subject', false));
  };

  const onChange = (name, value = '') => {
    if (name === 'curriculumId') {
      const find = curriculumList.find((item) => item._id === value);
      setInputForm({
        ...form,
        [name]: value,
        curriculum: find ? `${find.shortName} - ${find.name}` : '',
        curriculumElements: {}
      });
    } else {
      setInputForm({ ...form, [name]: value });
    }
  };

  const onApply = () => {
    onClose();
    const filter = {
      ...form
    };
    dispatch(updateFilter('subject', filter));
    dispatch(updateSkip('subject', 0));
    navigate(pathname, { state: filter });
  };

  return (
    <DialogConfirmCancel
      id='subject-filter'
      open={open}
      title='Filter'
      maxWidth='xs'
      onCancel={onClose}
      onConfirm={onApply}
      textConfirm='Apply'
    >
      <Box className='grid grid-cols-4 gap-4'>
        <div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Code
          </Typography>
        </div>
        <div className='col-span-3'>
          <InputField
            id='code'
            name='code'
            error={form.errors?.code}
            helperText={form.errors?.code}
            value={form.code}
            onChange={(e) => onChange('code', e.target.value)}
          />
        </div>
        <div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Name
          </Typography>
        </div>
        <div className='col-span-3'>
          <InputField
            id='name'
            name='name'
            error={form.errors?.name}
            helperText={form.errors?.name}
            value={form.name}
            onChange={(e) => onChange('name', e.target.value)}
          />
        </div>
        {['unassigned', 'assigned', 'all'].includes(curriculumId) && existLinceseAssessment && (
          <>
            <div>
              <Typography
                variant='inherit'
                className='font-bold capitalize'
                color='primary'
                align='right'
                component='p'
              >
                Curriculum
              </Typography>
            </div>
            <div className='col-span-3'>
              <SelectField
                id='curriculumId'
                name='curriculumId'
                value={form.curriculumId}
                onChange={(e) => onChange('curriculumId', e.target.value)}
                placeholder={'Choose a curriculum'}
                options={
                  curriculumList.map((item) => ({
                    value: item._id,
                    label: `${item.shortName} - ${item.name}`
                  })) || []
                }
              />
            </div>
          </>
        )}

        <FormCurriculumElements
          formData={form?.curriculumElements || {}}
          onChangeAlert={onChange}
          currentCurriculum={
            ['unassigned', 'assigned', 'all'].includes(curriculumId)
              ? curriculumList?.find((item) => form.curriculumId === item._id)
              : curriculumList?.find((item) => curriculumId === item._id)
          }
        />
      </Box>
    </DialogConfirmCancel>
  );
};

export default FilterDialog;
